const createMutation = `
mutation ($identityId: String!, $roleId: String!, $propagate: Boolean) {
  create_identity_role(body: { identity_id: $identityId, role_id: $roleId, propagate: $propagate }) {
      id
  }
}   
`;

const deleteMutation = `
mutation ($id: String!) {
  delete_identity_role(id: $id)
}   
`;

const updateMutation = `
mutation ($id: String!, $role_id: String, $propagate: Boolean, $required: Boolean) {
  update_identity_role(body: { role_id: $role_id, propagate: $propagate, required: $required }, id: $id) {
      id
  }
}   
`;

const identityRoleListQuery = `
query ($filter: String, $offset: Int, $order: String, $limit: Int) {
    identity_role_list(filter: $filter, offset: $offset, order: $order, limit: $limit) {
        identity_role_count
        identity_role_list {
            identity_id_identity {
                identity_type
                name
            }
            identity_id
            role_id
            id
            role_id_role{
                deleted_at
            }
            propagate
        }
    }
}`;

const identityRoleListCountQuery = `
query ($filter: String) {
    identity_role_list(filter: $filter, offset: 0, order: "+id", limit: 0) {
        identity_role_count
    }
}`;

export {
    createMutation,
    deleteMutation,
    identityRoleListCountQuery,
    identityRoleListQuery,
    updateMutation,
};
